import { MutationResponse } from './interfaces';
import { orgsRequest } from './request';

const DELETE_FINANCIAL_ACCOUNT_NODE_MUTATION = `
mutation FinancialAcctDelete($finAcctId: ID!) {
  financialAcctDelete(finAcctId: $finAcctId) {
    success
    errors {
      message
      type
    }
  }
}`;

export const deleteFinancialAccountNode = async (
  finAcctId: string,
): Promise<MutationResponse> => {
  const deleteFinancialAccountRes = await orgsRequest(
    DELETE_FINANCIAL_ACCOUNT_NODE_MUTATION,
    { finAcctId },
  );
  const deleteFinancialAccountJson = await deleteFinancialAccountRes.json();

  if (deleteFinancialAccountJson.errors) {
    throw new Error(`Could not delete financial account ${finAcctId}`);
  }
  return deleteFinancialAccountJson.data.financialAccountResponse;
};
